import Avatar from '@components/dataDisplay/Avatar';
import Icon from '@components/dataDisplay/Icons/Icon';
import { useDocument } from '@nandorojo/swr-firestore';
import React from 'react';
import styled from 'styled-components';

export const Tag = styled.div`
  padding: 6px 8px;
  background-color: var(--buttonBackgroundColor);
  color: var(--buttonTextColor);
  border-radius: var(--cardBorderRadius);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  text-align: center;

  .tag-x-btn {
    display: none;
  }

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    .tag-x-btn {
      display: block;
    }
  }
`;

type Props = {
  handleDelete: (i) => void;
  id: string;
  index: number;
  collectionPath: string;
  data?: any; // 외부에서 전달받은 데이터 (myInventory 모드용)
};
function TagItem({ handleDelete, index, id, collectionPath, data: externalData }: Props) {
  const { data: fetchedData } = useDocument<any>(
    externalData ? null : `${collectionPath}/${id}`,
    { listen: true },
  );

  const data = externalData || fetchedData;

  if (!data) return null;

  const photoURL =
    data?.imgURL ||
    data?.imageURL ||
    data?.thumbnail ||
    data?.thumbnailURL ||
    data?.photoURL ||
    '';
  return (
    <Tag onClick={() => handleDelete(index)}>
      <Avatar size="16px" photoURL={photoURL} />
      <span>{data?.title || data?.value || data?.name || id}</span>
      <Icon name="X12" color="var(--buttonTextColor)" className="tag-x-btn" />
    </Tag>
  );
}

export default TagItem;
